import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RepairDetailsComponent } from './repair-details/repair-details.component';

const routes: Routes = [{ path: '', component: RepairDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimsFeatureRepairDetailsRoutingModule {}
